import { observer } from 'mobx-react-lite';
import { withDefaultProps } from 'react-default-props-context';
import { QuestionT } from 'src/api/types/QuestionT';
import { cn } from 'src/frames/utils/cn';
import './ProgressBar.scss';

type PropsT = {
  className?: any;
};

type DefaultPropsT = {
  questionIdx: number;
  questions: QuestionT[];
};

export const ProgressBar = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    const percentage = Math.min(
      100,
      (100 * props.questionIdx) / props.questions.length
    );
    return (
      <div className={cn('ProgressBar', props.className)}>
        <div
          style={{ width: `${percentage}%` }}
          className={'ProgressBar__Bar'}
        ></div>
      </div>
    );
  })
);
